export default __webpack_public_path__ + "media/images/mailer/icon_reply-9f490991424fcd902a8e1aa05f236f37.png";